import LandingComponent from "./components/LandingComponent";
import React from "react";

export default function Landing () {
    return (
        <LandingComponent />
    );
}